// The shared slim items read (app-shell 2026-09-14, lever 3): the fields the Catalog stats strip, its
// brand / created-by lists, the Originals Overview, Settings' brand manager, the brand auto-sync and
// the pass-2 link index read — of every item, and NEVER `images` (629 B a row, 60 % of `select *`).
// Stage 0 had every portal pay `select *` (9 pages / 6.9 MB) at boot; this is 9 pages / 1.29 MB, and
// only once a screen that reads it is open. One-letter aliases keep the JSON keys from being most of
// the payload (the same fields spelled out measure 1.9 MB); `flatten` gives the rows back their names,
// flat, the shape fetchAllItemsRaw gave (`{ ...data, id }`). Ordered by id: offset paging on anything
// non-unique duplicates and drops rows (D3). One React Query keyed UNDER ['items'] so the catalog
// realtime (Tier A, useCatalogRealtime) invalidates it — an item edit anywhere refreshes the stats.
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { supabase } from '../supabase';
import { fetchAllPaged } from '../utils/pgIn';

export const ITEMS_STATS_KEY = ['items', 'stats-slim'];
// alias → the field it carries (data->field)
const ALIAS = { b: 'brand', k: 'sku', m: 'model', s: 'status', a: 'assignedTo', c: 'created_by_name', t: 'material', g: 'gender', o: 'developmentOrder', f: 'frameCategory' };
export const ITEMS_STATS_SELECT = ['id', ...Object.entries(ALIAS).map(([a, f]) => `${a}:data->${f}`)].join(',');

const flatten = (r) => { const row = { id: r.id }; for (const [a, f] of Object.entries(ALIAS)) row[f] = r[a] ?? undefined; return row; };

export async function fetchItemsStatsSlim() {
  const rows = await fetchAllPaged(() => supabase.from('items').select(ITEMS_STATS_SELECT).order('id'), { label: 'items stats-slim' });
  return rows.map(flatten);
}

/** Every item, slim and flat — [] until read; loaded only when `enabled`. */
export function useItemsStatsSlim(enabled = true) {
  const q = useQuery({ queryKey: ITEMS_STATS_KEY, queryFn: fetchItemsStatsSlim, enabled, staleTime: 5 * 60 * 1000, gcTime: 30 * 60 * 1000 });
  return q.data || EMPTY;
}
const EMPTY = [];

/** The refresh the item mutation paths call after a write — an invalidation, never a manual refetch. */
export function useRefreshItemsStats() {
  const queryClient = useQueryClient();
  return useCallback(() => { queryClient.invalidateQueries({ queryKey: ITEMS_STATS_KEY }); }, [queryClient]);
}
